/**
 * Port vocabulary for the event/action node graph.
 *
 * An output port `provides` exactly one kind; an input port `accepts` a list
 * of kinds and may cap its number of wires with `max`. Every connection rule
 * that does not need graph state is derived from these declarations.
 */
export const PORT_KIND = Object.freeze({
    // An event source: a UI object, the page or a GPIO entity node.
    OBJECT: 'object',
    // An event firing its connected actions.
    TRIGGER: 'trigger',
    // The live state of a GPIO entity: feeds a GPIO binding or a comparison.
    GPIO_STATE: 'gpio-state',
    // A bound value, from a GPIO binding into a UI object.
    VALUE: 'value',
})

// Implicit output port on every UI object whose schema declares events.
export const OBJECT_EVENTS_PORT = Object.freeze({ id: 'events', label: 'Events', provides: PORT_KIND.OBJECT })

// Implicit input port on every UI object a GPIO state binding can drive.
export const OBJECT_BINDINGS_PORT = Object.freeze({ id: 'in', label: 'GPIO bindings', accepts: [PORT_KIND.VALUE] })

export { isPortCompatible } from '../graphPorts.js'
